import { CourseInboxAPI } from '@business/api/course_inbox';
import { CourseInboxResponse, CourseInboxId, CourseInboxSearchParams } from '@business/entities/course_inbox';
import { CompanyId } from '@business/entities/companies';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { R } from '@core/utils/r';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { map, switchMap } from 'rxjs/operators';

export class CourseInboxBloc extends BaseBloc {
  private readonly additionRepo = new Repository<CourseInboxResponse>({
    getItemId: item => item.id,
  });

  readonly additiones$ = this.additionRepo.items$;
  readonly selectCourseInbox = this.additionRepo.selectItem;

  onReset() {
    this.additionRepo.reset();
  }

  fetchCourseInboxs = (data?: CourseInboxSearchParams) => {
    return CourseInboxAPI.fetchCourseInboxs(data);
  };

  fetchCourseInbox = (id: CourseInboxId) => {
    return CourseInboxAPI.fetchCourseInbox(id).pipe(
      this.additionRepo.ops.upsertOne(item => ({ item })),
      // handleMessage({ error: requestMessage('fetch_addition_error') }),
    );
  };

  createCourseInbox = (data: Partial<CourseInboxResponse>) => {
    return CourseInboxAPI.createCourseInbox(data).pipe(
      this.additionRepo.ops.addOne(item => item),
      handleMessage({
        // type: requestMessage('create_addition'),
      }),
    );
  };

  updateCourseInbox = (id: CourseInboxId, data: Partial<CourseInboxResponse>) => {
    return CourseInboxAPI.updateCourseInbox(id, data).pipe(
      this.additionRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        // type: requestMessage('update_addition'),
      }),
    );
  };

  deleteCourseInbox = (id: CourseInboxId) => {
    return showDeleteConfirmation('Delete Categeory', 'Do you really want to remove this addition?').pipe(
      switchMap(() => CourseInboxAPI.deleteCourseInbox(id)),
      this.additionRepo.ops.removeOne(() => id),
      handleMessage({
        // type: requestMessage('delete_addition'),
      }),
    );
  };
}
